<template>
  <v-container
    v-if="isGlobalStyleSettings"
  >
    <v-layout
      class="mb-4"
      row
      :align-content-center="true"
      :justify-space-between="true"
    >
      <h2>Styles Settings</h2>
      <apply-default-settings/>
    </v-layout>
    <button-settings/>
    <input-settings/>
    <radio-buttons-settings/>
    <checkboxes-settings/>
    <!--<content-text-settings/>-->
    <links-settings/>
    <!--<headings-settings/>-->
    <header-image-size-setup/>
    <decorative-elements-settings/>
    <main-header-settings/>
    <footer-settings/>
    <error-settings/>
  </v-container>
</template>

<script>
  import InputSettings from './styleForms/InputSettings'
  import RadioButtonsSettings from './styleForms/RadioButtonsSettings'
  import CheckboxesSettings from './styleForms/CheckboxesSettings'
  import ButtonSettings from './styleForms/ButtonSettings'
  import FooterSettings from './styleForms/FooterSettings'
  import MainHeaderSettings from './styleForms/MainHeaderSettings'
  import ContentTextSettings from './styleForms/ContentTextSettings'
  import HeaderImageSizeSetup from './styleForms/HeaderImageSizeSetup'
  import HeadingsSettings from './styleForms/HeadingsSettings'
  import LinksSettings from './styleForms/LinksSettings'
  import DecorativeElementsSettings from './styleForms/DecorativeElemntsSettings'
  import ErrorSettings from './styleForms/ErrorSettings'
  import ApplyDefaultSettings from './styleForms/ApplyDefaultSettings'
  import { mapGetters } from 'vuex'
  export default {
    name: "StylesSettings",
    components: {
      HeaderImageSizeSetup,
      ButtonSettings,
      InputSettings,
      RadioButtonsSettings,
      CheckboxesSettings,
      FooterSettings,
      MainHeaderSettings,
      ContentTextSettings,
      HeadingsSettings,
      LinksSettings,
      DecorativeElementsSettings,
      ErrorSettings,
      ApplyDefaultSettings
    },
    computed: {
      ...mapGetters(['isGlobalStyleSettings'])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/index.vue